module.exports = __webpack_public_path__ + "img/instagram.ba191662.svg";